import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MuiLink from '@material-ui/core/Link';
import { Link } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const FULFILMENT_APP_ORIGIN = BASE_URL.replace('{app}', 'fulfilment');

const ShipmentFormatter = ({ shipment }) => {
  const isSameOrigin = window.location.origin === FULFILMENT_APP_ORIGIN;

  return (
    <Fragment key={shipment?.id}>
      {isSameOrigin ? (
        <MuiLink variant="subtitle1" component={Link} to={`/shipments/${shipment.id}`}>
          {shipment.number ?? 'Concept'}
        </MuiLink>
      ) : (
        <MuiLink variant="subtitle1" href={`${FULFILMENT_APP_ORIGIN}/shipments/${shipment.id}`}>
          {shipment.number ?? 'Concept'}
        </MuiLink>
      )}
    </Fragment>
  );
};

ShipmentFormatter.propTypes = {
  shipment: PropTypes.object,
};

ShipmentFormatter.defaultProps = {
  shipment: null,
};

export default ShipmentFormatter;
